import type { UseFetchOptions } from 'nuxt/app';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
interface fetchOptions<T = any> extends UseFetchOptions<T> {
  ignoreStoreError?: boolean;
}

export async function useFetchApi<T>(
  url: string,
  options: fetchOptions,
  success?: SuccessAlert,
): Promise<T | unknown> {
  const { $api } = useNuxtApp();

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const response = await $api<T>(url, options as any);

  if (success) {
    const store = successStore();
    store.ADD_SUCCESS(success);
  }

  return response as T;
}
